import React, { useEffect } from 'react';
import usePreview3DStore from '../store';

export const EmptySceneData = ({ children, onSceneLoaded }: { children: React.ReactNode; onSceneLoaded: (isNew: boolean) => void }) => {
    const [saveVersion, zkScene, zkProduct, setZkScene] = usePreview3DStore((store) => [store.saveVersion, store.zkScene, store.zkProduct, store.setZkScene]);

    useEffect(() => {
        // Create the empty scene
        const zkScene = new Zakeke.Scene();
        // Disable delayed material loading as default, because design materials ust be loaded asap
        zkScene.setUseDelayedMaterialLoading(false);
        setZkScene(zkScene);

        // Add an empty scene to ZkProduct
        const modelScene = new MPlaza.ModelScene();
        modelScene.set('isDefault', true);
        zkProduct!.get('scenes').add(modelScene);

        onSceneLoaded(true);
    }, [saveVersion]);

    if (!zkScene) return null;

    return children;
};
